import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "loading-view" }


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingView',
  setup(__props) {

// import { theme } from '@/config/theme';

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "logo-row" }, null, -1)
  ])))
}
}

})